import React from 'react';
import { Grid, Typography } from "@mui/material";
import { utils } from '../../utils/utils';

const TotalPayed = ({ totalPayed, currency, showAlways, variant }) => {
    return ((showAlways || (!!totalPayed && totalPayed > 0)) && <Grid container alignItems='baseline' justifyContent='space-between'>
        <Typography variant={variant} component='span' id='totalPayedTitle'>
            Total Pagado:
        </Typography>
        <Typography variant={variant} component='span' id='totalPayedAmount'>
            {currency} <strong>{utils.formatMoney(totalPayed)}</strong>
        </Typography>
    </Grid>);
}
export default TotalPayed;